<template>
  <div class="bg-white p-4 sm:p-6 lg:p-8 rounded-lg shadow-lg w-full max-w-lg lg:max-w-6xl mb-8">
    <h2 class="text-lg sm:text-xl lg:text-2xl font-bold mb-4 text-gray-800">Manage Staffs</h2>

    <!-- Align Add Button to the Right -->
    <div class="flex justify-end mb-4">
      <button class="px-4 py-2 rounded-lg bg-green hover:bg-green hover:text-gray-200 text-gray-100"
        @click="openAddStaffModal">
        Add
      </button>
    </div>

    <!-- Staffs Table -->
    <table class="w-full text-left border-collapse">
      <thead>
        <tr>
          <th class="p-2 border-b-2">Staff Name</th>
          <th class="p-2 border-b-2">Phone</th>
          <th class="p-2 border-b-2">Email</th>
          <th class="p-2 border-b-2">Joined Date</th>
          <th class="p-2 border-b-2">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(staff, index) in staffs" :key="index" class="hover:bg-gray-100">
          <td class="p-2 border-b">{{ staff.name }}</td>
          <td class="p-2 border-b">{{ staff.phone }}</td>
          <td class="p-2 border-b">{{ staff.email }}</td>
          <td class="p-2 border-b">{{ formatDate(staff.createdAt) }}</td>
          <td class="p-2 border-b">
            <button @click="viewStaff(staff)" class="text-blue-500 hover:text-blue-700 focus:outline-none px-2">
              <i class="fas fa-eye"></i>
            </button>
            <button @click="editStaff(staff)" class="text-gray-500 hover:text-gray-700 focus:outline-none px-2">
              <i class="fas fa-edit"></i>
            </button>
            <button @click="deleteStaff(staff.id)" class="text-red-500 hover:text-red-700 focus:outline-none px-2">
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
        <tr v-if="staffs.length === 0">
          <td colspan="5" class="text-center text-gray-500 p-4">No staffs available.</td>
        </tr>
      </tbody>
    </table>
      <AddStaffModal v-if="isAddStaffModalOpen" @closeModal="isAddStaffModalOpen = false" />
      <ViewStaffModal v-if="isViewStaffModalOpen" :staff="selectedStaff" @closeModal="isViewStaffModalOpen = false" />
      <EditStaffModal v-if="isEditStaffModalOpen" :staff="selectedStaff" @closeModal="isEditStaffModalOpen = false" />


  </div>

</template>

<script>

import { mapActions, mapState } from 'vuex';
import AddStaffModal from './AddStaffModal.vue';
import ViewStaffModal from './ViewStaffModal.vue';
import EditStaffModal from './EditStaffModal.vue';

export default {
  data() {
    return {
      isAddStaffModalOpen: false,
      isViewStaffModalOpen: false,
      isEditStaffModalOpen: false,
      selectedStaff: null,
    };
  },
  async mounted(){
    await this.fetchStaffs();
   },
  components: {
    AddStaffModal,
    ViewStaffModal,
    EditStaffModal,
  },
  computed: {
    ...mapState('staffs', {
      staffs: state => state.staffs,
    })
  },
  methods: {
    ...mapActions('staffs', {fetchStaffs : 'fetchStaffs'}),
    openAddStaffModal() {
      this.isAddStaffModalOpen = true;
    },

    viewStaff(staff) {
      console.log(staff);
      this.selectedStaff = staff;
      this.isViewStaffModalOpen = true;
    },
    editStaff(staff) {
      this.selectedStaff = staff;
      this.isEditStaffModalOpen = true;
    },
    deleteStaff(orderId) {
      this.$emit('deleteitem', orderId);
    },
      formatDate(date) {
        return new Date(date).toLocaleDateString();
      },
  }
};
</script>